/* =====================================================================
   Cave Larégnère — Ajout rapide au panier (autonome, réutilise le panier Eurus).
   N'ouvre PAS de panier parallèle : POST /cart/add.js sur le MÊME panier Shopify,
   puis rafraîchit le compteur (#cart-icon-bubble) et le drawer (#CartDrawer) via la
   Section Rendering API, émet les events Eurus, et affiche une confirmation sobre.
   Délégation d'événements → fonctionne aussi sur les cartes injectées par les filtres.
   ===================================================================== */
(function () {
  'use strict';
  var LIVE = null, TOAST = null;

  function ensureUI() {
    if (!LIVE) {
      LIVE = document.createElement('div');
      LIVE.className = 'cl-visually-hidden';
      LIVE.setAttribute('aria-live', 'polite');
      LIVE.setAttribute('role', 'status');
      document.body.appendChild(LIVE);
    }
    if (!TOAST) {
      TOAST = document.createElement('div');
      TOAST.className = 'cl-toast';
      TOAST.setAttribute('role', 'status');
      document.body.appendChild(TOAST);
    }
  }
  function announce(msg) { ensureUI(); LIVE.textContent = ''; setTimeout(function(){ LIVE.textContent = msg; }, 30); }
  function showToast(html) {
    ensureUI();
    TOAST.innerHTML = html;
    TOAST.classList.add('is-shown');
    clearTimeout(TOAST._t);
    TOAST._t = setTimeout(function () { TOAST.classList.remove('is-shown'); }, 4500);
  }
  function sectionIdOf(sel) {
    var el = document.querySelector(sel);
    if (!el) return null;
    var host = el.closest('[id^="shopify-section-"]');
    return host ? host.id.replace('shopify-section-', '') : null;
  }
  function replaceSection(id, html) {
    if (!id || !html) return;
    var host = document.getElementById('shopify-section-' + id);
    if (!host) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#shopify-section-' + id);
    host.innerHTML = fresh ? fresh.innerHTML : tmp.innerHTML;
  }
  function setLabel(btn, text) {
    var l = btn.querySelector('.cl-atc__label');
    if (l) l.textContent = text;
  }
  function getLabel(btn) {
    var l = btn.querySelector('.cl-atc__label');
    return l ? l.textContent : 'Ajouter au panier';
  }

  /* Le store panier du thème. Absent tant qu'Alpine n'a pas démarré (ce
     fichier est chargé avant vendors.js), d'où la lecture à chaque clic. */
  function helperPanier() {
    try {
      return (window.Alpine && Alpine.store && Alpine.store('xCartHelper')) || null;
    } catch (e) { return null; }
  }

  function addToCart(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    // Quantité choisie sur la carte (paliers 1 / 3 / 6). Absente ailleurs → 1.
    var qte = parseInt(btn.getAttribute('data-qte'), 10);
    if (!qte || qte < 1 || qte > 99) { qte = 1; }
    var original = getLabel(btn);
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    btn.classList.remove('is-error', 'is-added');

    // On demande au thème QUELLES sections rafraîchir, plutôt que de le deviner :
    // c'est le même contrat que son propre formulaire produit.
    var aide = helperPanier();
    var cibles = null;
    try {
      if (aide && typeof aide.getSectionsToRender === 'function') { cibles = aide.getSectionsToRender(); }
    } catch (e) {}
    var bubbleSec = sectionIdOf('#cart-icon-bubble') || sectionIdOf('#mobile-cart-icon-bubble');
    var drawerSec = sectionIdOf('#CartDrawer');
    var sections = cibles && cibles.length
      ? cibles.map(function (s) { return s.id; })
      : [bubbleSec, drawerSec].filter(Boolean);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(id, 10), quantity: qte }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, status: r.status, d: d }; }); })
      .then(function (res) {
        btn.setAttribute('aria-busy', 'false');
        btn.classList.remove('is-loading');
        if (!res.ok) { throw new Error((res.d && res.d.description) || 'add_error'); }
        var d = res.d;
        btn.classList.add('is-added');
        setLabel(btn, 'Ajouté ✓');
        setTimeout(function () { btn.classList.remove('is-added'); setLabel(btn, original); }, 2200);
        announce('Produit ajouté au panier.');

        // On laisse le thème rafraîchir ses sections. C'est important : sa
        // méthode ne remplace que l'intérieur de `#CartDrawer`, alors que notre
        // repli remplaçait `#shopify-section-cart-drawer` en entier — donc la
        // racine `x-data` du tiroir. Le composant Alpine était détruit puis
        // recréé, et le panier se retrouvait bloqué jusqu'au rechargement.
        var rendu;
        if (aide && typeof aide.reRenderSections === 'function') {
          try { rendu = Promise.resolve(aide.reRenderSections(d.sections)); } catch (e) { rendu = null; }
        }
        if (!rendu) {
          if (d.sections) {
            replaceSection(bubbleSec, d.sections[bubbleSec]);
            replaceSection(drawerSec, d.sections[drawerSec]);
          }
          rendu = Promise.resolve();
        }

        rendu.then(function () {
          try {
            var bulle = document.getElementById('cart-icon-bubble');
            if (aide && bulle) {
              var n = parseInt((bulle.textContent || '').trim(), 10);
              if (!isNaN(n)) { aide.currentItemCount = n; }
            }
          } catch (e) {}
          /* RETIRÉ le 2026-08-07 : l'ouverture automatique du tiroir
             (`Alpine.store('xMiniCart').openCart()`) est le suspect principal du
             panier qui se bloque et n'est récupérable qu'en rechargeant la page.
             Impossible à reproduire côté serveur ; on l'enlève pour l'isoler.
             Le gain qu'elle apportait — montrer le rappel point relais et le
             bouton Commander — ne vaut pas le risque d'un panier inaccessible.
             Ne pas la remettre sans l'avoir testée dans un vrai navigateur. */
          showToast('<span class="cl-toast__ico" aria-hidden="true">✓</span><span class="cl-toast__txt">Ajouté au panier</span><a class="cl-toast__link" href="/cart">Voir le panier</a>');
        });

        try {
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed', { bubbles: true, detail: d }));
          document.dispatchEvent(new CustomEvent('eurus:product:added', { bubbles: true, detail: d }));
        } catch (e) {}
      })
      .catch(function () {
        btn.setAttribute('aria-busy', 'false');
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        setLabel(btn, 'Réessayer');
        announce('Une erreur est survenue, veuillez réessayer.');
        setTimeout(function () { btn.classList.remove('is-error'); setLabel(btn, original); }, 2600);
      });
  }

  /* Sélecteur de quantité (− valeur +) posé au-dessus du bouton d'achat. La
     valeur est reportée sur le bouton via data-qte : aucun état à conserver
     ailleurs, et le rafraîchissement d'une section ne peut pas le désynchroniser. */
  function reporterQte(champ) {
    var n = parseInt(champ.value, 10);
    if (isNaN(n) || n < 1) { n = 1; }
    if (n > 24) { n = 24; }          // au-delà, c'est une commande pro : au téléphone
    champ.value = n;
    var carte = champ.closest('.recipe-products__card, .rmaillage__card');
    var achat = carte && carte.querySelector('.cl-atc[data-variant-id]');
    if (achat) { achat.setAttribute('data-qte', n); }
    var moins = champ.parentNode.querySelector('.cl-qte__pas[data-pas="-1"]');
    if (moins) { moins.disabled = n <= 1; }
    return n;
  }
  document.addEventListener('click', function (e) {
    var pas = e.target.closest('.cl-qte__pas');
    if (!pas) return;
    e.preventDefault();
    var champ = pas.parentNode.querySelector('.cl-qte__val');
    if (!champ) return;
    champ.value = (parseInt(champ.value, 10) || 1) + parseInt(pas.getAttribute('data-pas'), 10);
    reporterQte(champ);
  });
  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('cl-qte__val')) { reporterQte(e.target); }
  });
  // Le « − » démarre désactivé : à 1, il n'y a rien à retirer.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cl-qte__val').forEach(reporterQte);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cl-atc[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn);
  });
})();

/* Tiroir de filtres mobile : construction à l'ouverture -----------------------
   Le thème rend chaque valeur de filtre deux fois — barre ordinateur ET tiroir
   mobile. Sur la grande cave cela faisait 594 lignes pour 297 valeurs réelles.
   snippets/input-filter.liquid ne rend plus, côté tiroir, que les valeurs
   actives ; les autres sont recopiées ici depuis la liste de l'ordinateur, à
   l'ouverture du groupe concerné.

   Sur ordinateur, aucun groupe du tiroir n'est ouvert : la liste n'est jamais
   construite, ni en nœuds ni en composants Alpine.

   En cas de pépin (liste source introuvable, erreur de copie), on laisse la
   liste en l'état : les filtres actifs restent affichés et soumis. */
(function () {
  'use strict';

  function hydrater(ul) {
    if (!ul || ul.dataset.clPret) return;
    var cle = ul.getAttribute('data-cl-key');
    if (!cle) return;

    var source = null;
    var listes = document.querySelectorAll('.cl-facet-list[data-cl-key]');
    for (var i = 0; i < listes.length; i++) {
      if (listes[i] !== ul && !listes[i].hasAttribute('data-cl-lazy') &&
          listes[i].getAttribute('data-cl-key') === cle) { source = listes[i]; break; }
    }
    if (!source) return;                 /* pas de source : on ne touche à rien */

    ul.dataset.clPret = '1';

    /* les valeurs déjà présentes (= actives) ne doivent pas être dupliquées */
    var deja = {};
    ul.querySelectorAll('input[type="checkbox"]').forEach(function (i) { deja[i.value] = true; });

    var frag = document.createDocumentFragment();
    source.querySelectorAll('.cl-facet-item').forEach(function (li) {
      var src = li.querySelector('input[type="checkbox"]');
      if (!src || deja[src.value]) return;
      var copie = li.cloneNode(true);
      var inp = copie.querySelector('input[type="checkbox"]');
      var lab = copie.querySelector('label');
      /* les identifiants doivent rester uniques entre les deux formulaires */
      var id = inp.id.replace(/^Filter-(above|aside)-/, 'Filter-drawer-');
      inp.id = id;
      if (lab) lab.setAttribute('for', id);
      inp.checked = false;
      inp.setAttribute('data-cl-clone', '1');
      frag.appendChild(copie);
    });
    ul.appendChild(frag);
  }

  /* Déclencheur principal : l'apparition du tiroir lui-même.
     Se fier au seul clic sur l'en-tête d'un groupe ne suffit pas — un groupe
     peut être déplié d'origine, et l'utilisateur verrait alors une liste vide.
     Dès que le tiroir devient visible, on construit tous ses groupes d'un coup.
     Sur ordinateur le tiroir ne s'affiche jamais : rien n'est construit. */
  function surveillerTiroir() {
    var tiroir = document.querySelector('.form-drawer');
    if (!tiroir || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entrees, obs) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.disconnect();
        tiroir.querySelectorAll('.cl-facet-list[data-cl-lazy]').forEach(function (ul) {
          try { hydrater(ul); } catch (err) { /* on laisse la liste telle quelle */ }
        });
      });
    }, { threshold: 0 }).observe(tiroir);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', surveillerTiroir);
  } else {
    surveillerTiroir();
  }
  /* le thème réécrit le tiroir à chaque filtrage : on réarme la surveillance */
  document.addEventListener('eurus:collection:reloaded', surveillerTiroir);

  /* Filets : l'ouverture d'un groupe et la saisie dans la recherche interne.
     On écoute en délégation, le tiroir étant réécrit à chaque filtrage. */
  document.addEventListener('click', function (e) {
    var bouton = e.target.closest('.form-drawer .js-filter > button, .form-drawer .facets__summary');
    if (!bouton) return;
    var groupe = bouton.closest('.js-filter');
    if (!groupe) return;
    try { hydrater(groupe.querySelector('.cl-facet-list[data-cl-lazy]')); }
    catch (err) { /* on laisse la liste telle quelle */ }
  }, true);

  /* Les lignes recopiées portent `@change="onSubmit()"`, une directive Alpine.
     Alpine 3 initialise bien les nœuds ajoutés après coup, mais on ne veut pas
     que le filtrage repose sur cette hypothèse : si la case recopiée change,
     on relaie l'événement sur un champ du même formulaire qu'Alpine a relié au
     chargement (le prix, ou le tri). `onSubmit()` sérialise de toute façon le
     formulaire entier — la case cochée est donc prise en compte — et son
     minuteur interne absorbe un éventuel double appel. */
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (!i || !i.matches || !i.matches('input[data-cl-clone]')) return;
    var form = i.closest('form');
    if (!form) return;
    var relais = form.querySelector('input.price-input') ||
                 form.querySelector('input[\\@change]:not([data-cl-clone])') ||
                 form.querySelector('[x-on\\:change]:not([data-cl-clone])');
    if (relais && relais !== i) {
      relais.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    /* Dernier filet, si le formulaire ne contient aucun champ relié : envoi
       natif. Le formulaire n'a ni action ni method, donc c'est un GET sur
       l'adresse courante avec les filtres cochés — la bonne URL, au prix d'un
       rechargement complet plutôt qu'un rafraîchissement en arrière-plan. */
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  });

  /* Filet : si le tiroir s'ouvre déjà déplié, on construit à la première frappe
     dans le champ de recherche interne. */
  document.addEventListener('focusin', function (e) {
    var champ = e.target.closest('.form-drawer .cl-facet-search');
    if (!champ) return;
    var groupe = champ.closest('.js-filter');
    if (!groupe) return;
    try { hydrater(groupe.querySelector('.cl-facet-list[data-cl-lazy]')); }
    catch (err) { /* idem */ }
  }, true);
})();

/* Recherche interne dans les longues listes de filtres (Appellation, Producteur…) */
(function () {
  'use strict';
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  document.addEventListener('input', function (e) {
    var input = e.target.closest('.cl-facet-search');
    if (!input) return;
    var wrap = input.closest('.cl-facet-search-wrap');
    var list = wrap && wrap.parentNode.querySelector('.cl-facet-list');
    if (!list) return;
    var q = norm(input.value.trim());
    var shown = 0;
    list.querySelectorAll('.cl-facet-item').forEach(function (li) {
      /* Le libellé est lu dans la ligne elle-même : l'attribut data-label
         dupliquait ce texte sur chaque valeur de filtre (jusqu'à 600 par page).
         On retire le compteur « (12) » de fin pour ne pas chercher sur lui. */
      var lbl = li.getAttribute('data-label') || li.textContent.replace(/\s*\(\d+\)\s*$/, '');
      var match = q === '' || norm(lbl).indexOf(q) > -1;
      li.style.display = match ? '' : 'none';
      if (match) shown++;
    });
    var empty = wrap.querySelector('.cl-facet-search__empty');
    if (empty) empty.hidden = shown !== 0;
  });
})();
